<template>
  <v-container fluid class="pa-5">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <template v-if="!isLoading">
      <template v-if="boards.length === 0 && !isFiltered">
        <v-card class="card-container d-flex pa-6" elevation="0">
          <v-row>
            <v-col cols="12">
              <span class="title-text">จัดการข่าว</span>
            </v-col>

            <v-col
              cols="12"
              class="d-flex flex-column align-center justify-center"
              style="min-height: 88vh"
            >
              <div class="d-flex flex-column align-center">
                <v-img>
                  <img
                    src="@/assets/not_exist_search.svg"
                    alt="no-data"
                    width="103"
                    height="103"
                  />
                </v-img>
                <span class="no-data-text mb-4"> ยังไม่มีรายการข่าว </span>

                <v-btn
                  color="#F4811F"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreateModal"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  สร้างข่าวใหม่
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-else>
        <v-card class="card-container pa-2" elevation="0">
          <v-card-title>
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-start"
              >
                <span class="title-text">จัดการข่าว</span>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-end"
              >
                <v-btn
                  color="#F4811F"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreateModal"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  สร้างข่าวใหม่
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                 <Select
                  :search.sync="search"
                  :selected-status.sync="selectedStatus"
                />
              </v-col>

              <v-col cols="12" class="mt-4">
                <template v-if="filteredBoards.length > 0">
                  <Table
                    :boards="filteredBoards"
                    @edit="openEditModal"
                    @delete="confirmDelete"
                  />
                </template>

                <template v-else>
                   <v-row>
                    <v-col
                      cols="12"
                      class="d-flex flex-column align-center justify-center"
                      style="min-height: 45vh"
                    >
                      <div class="d-flex flex-column align-center">
                        <v-img>
                          <img
                            src="@/assets/not_exist_search.svg"
                            alt="no-data"
                            width="103.8"
                            height="103.8"
                          />
                        </v-img>
                        <span class="no-data-text mb-4">
                          ไม่พบข้อมูลที่ค้นหา กรุณาลองใหม่อีกครั้ง
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </template>
    
    <!-- Dialog logic replaced with component -->
    <BoardFormDialog 
        v-model="dialog"
        :item="editedItem"
        :mode="editedIndex === -1 ? 'create' : 'edit'"
        @save="handleSave"
    />

  </v-container>
</template>

<script>
import Table from "@/components/AdminBoard/Table.vue";
import Select from "@/components/AdminBoard/Select.vue";
import BoardFormDialog from "@/components/AdminBoard/BoardFormDialog.vue";
import { 
    getAdminBoardsApi, 
    createBoardApi, 
    updateBoardApi, 
    deleteBoardApi 
} from "@/services/api/board";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "AdminBoard",
  components: {
    Table,
    Select,
    BoardFormDialog
  },

  data() {
    return {
      isLoading: false,
      boards: [],
      search: "",
      selectedStatus: "",
      
      dialog: false,
      editedIndex: -1,
      editedItem: {},
    };
  },

  async created() {
    await this.loadBoards();
  },

  computed: {
    isFiltered() {
      return !!this.search || !!this.selectedStatus;
    },
    
    filteredBoards() {
      let result = [...this.boards];

      if (this.selectedStatus) {
        result = result.filter(b => b.status === this.selectedStatus);
      }

      if (this.search) {
        const lowerSearch = this.search.toLowerCase();
        result = result.filter(b => 
            (b.title || "").toLowerCase().includes(lowerSearch) ||
            (b.detail || "").toLowerCase().includes(lowerSearch)
        );
      }

      return result;
    },
  },

  methods: {
    async loadBoards() {
      this.isLoading = true;
      try {
        const res = await getAdminBoardsApi({ limit: 1000 });
        if (res.data && res.data.data) {
             this.boards = res.data.data;
        } else {
             this.boards = [];
        }
      } catch (error) {
        console.error("Error loading boards:", error);
        swalAlert.Error("โหลดข้อมูลล้มเหลว");
      } finally {
        this.isLoading = false;
      }
    },

    openCreateModal() {
        this.editedIndex = -1;
        this.editedItem = null;
        this.dialog = true;
    },

    openEditModal(item) {
        this.editedIndex = this.boards.indexOf(item);
        this.editedItem = item;
        console.log('editedItem',this.editedItem);
        this.dialog = true;
    },

    async handleSave(payload) {
        // Validation handled in dialog or here if needed
        console.log('payload',payload);
        if (!payload.title || !payload.detail) {
             swalAlert.Warning("กรุณากรอกข้อมูลให้ครบถ้วน");
             return;
        }
        
        this.isLoading = true;
        try {
            const formData = new FormData();
            formData.append('title', payload.title);
            formData.append('detail', payload.detail);
            formData.append('status', payload.status);
            formData.append('tags', payload.tags);
            formData.append('author', payload.author || "Admin"); 
            
            if (payload.imageFile) {
                formData.append('image', payload.imageFile);
            } 
            
            if (this.editedIndex > -1) {
                // Update
                // Note: payload has all fields from localItem in dialog
                await updateBoardApi(this.editedItem.id, formData);
                swalAlert.Success("อัปเดตข้อมูลสำเร็จ");
            } else {
                // Create
                await createBoardApi(formData);
                 swalAlert.Success("สร้างข่าวสำเร็จ");
            }
            this.dialog = false;
            await this.loadBoards();
        } catch (error) {
             console.error("Error saving board:", error);
             swalAlert.Error("บันทึกข้อมูลล้มเหลว");
        } finally {
            this.isLoading = false;
        }
    },

    async confirmDelete(item) {
        const result = await swalAlert.Confirm({
            title: "ยืนยันการลบ",
            message: "คุณต้องการลบข่าวนี้ใช่หรือไม่?"
        });

        if (result.isConfirmed) {
            this.isLoading = true;
            try {
                await deleteBoardApi(item.id);
                swalAlert.Success("ลบข้อมูลสำเร็จ");
                await this.loadBoards();
            } catch (error) {
                 console.error("Error deleting board:", error);
                 swalAlert.Error("ลบข้อมูลล้มเหลว");
            } finally {
                this.isLoading = false;
            }
        }
    }
  },
};
</script>

<style scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}
.no-data-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.card-container {
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
}
.create-btn {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 40px !important;
  text-transform: none !important;
}
@media (max-width: 960px) {
  .create-btn {
    width: 100% !important;
  }
}
</style>